function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.0005 10V7H30.0005V10",
  stroke: "#FFD200",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.00049 30.22H7.76049V34.06H1.00049",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.0005 30.22H40.2305V34.06H45.6505",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.00049 18H1.00049V23H8.00049V18Z",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.0005 18H40.0005V23H47.0005V18Z",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.0005 13L40.0005 23H8.00049L11.0005 13C11.3605 12 12.0005 11.07 14.0005 11.07L34.0005 11C34.6576 10.9162 35.3228 11.0723 35.874 11.4398C36.4252 11.8072 36.8252 12.3612 37.0005 13V13Z",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0005 37.89H3.56049C2.14049 37.89 1.00049 37.41 1.00049 36V30C1.07711 29.2332 1.43303 28.5214 2.00049 28L8.00049 23H40.0005L46.2005 28.19C46.4538 28.429 46.6554 28.7173 46.793 29.0372C46.9306 29.3571 47.0012 29.7018 47.0005 30.05V36C47.0005 37.41 46.4105 37.89 44.0005 37.89H32.0005",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.0005 35H16.0005V40H32.0005V35Z",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.00049 38V42C4.00049 42.71 4.28049 43 5.00049 43H9.00049C9.71049 43 10.0005 42.71 10.0005 42V37.89",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.0005 38V42C38.0005 42.71 38.2805 43 39.0005 43H43.0005C43.7105 43 44.0005 42.71 44.0005 42V37.89",
  stroke: "#ACB5BF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white",
  transform: "translate(0.000488281)"
})));

function SvgRider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRider);
export default __webpack_public_path__ + "static/media/rider.34eca85b.svg";
export { ForwardRef as ReactComponent };